import axios from 'axios';

const ENDPOINT =
    '/actions/mg-motors-europe-module/site-controller/get-captcha-config';

// In-memory only — intentionally not sessionStorage so Cypress runs
// cannot bleed a cached `enabled: false` into a subsequent manual session.
let cachedResult = null;
let pending = null;

const fetchConfig = () => {
    if (cachedResult !== null) return Promise.resolve(cachedResult);
    if (pending) return pending;

    pending = axios
        .get(ENDPOINT)
        .then((res) => {
            cachedResult = res.data?.enabled ?? true;
            pending = null;
            return cachedResult;
        })
        .catch((err) => {
            pending = null;
            throw err;
        });

    return pending;
};

export const isCaptchaEnabled = () => fetchConfig();
